import React from "react";
import styled from "styled-components";

const PayPalForm = styled.form`
    display: inline-block;
    margin: 0 10px 10px 0;
`;

const PayPalImage = styled.input`
    border-radius: 3px;
    background-color: #ccc;
    padding: 7px 10px;
    vertical-align: middle;
`;

const PayPalButton = () => (
    <PayPalForm action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input type="hidden" name="hosted_button_id" value="X55FPCQPEH3EA" />
        <PayPalImage type="image" src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-100px.png" border="0" name="submit" title="Donate via PayPal" alt="Donate via PayPal" />
        <img alt="" border="0" src="https://www.paypal.com/en_GB/i/scr/pixel.gif" width="1" height="1" />
    </PayPalForm>
);

export default PayPalButton;